<div class="flex flex-col">
    <div class="flex flex-col text-center pt-24 px-20 pl-16">
        <h1 class="text-6xl pb-6">Beautiful analytics to grow smarter</h1>
        <p class="text-xl text-gray-600  pb-12">Powerful analytics and management tools to help you attract customers, optimize operations, and boost revenue.</p>
        <div class="flex justify-center">
            <glo-button icon="play-circle" value="Demo" />
            <button routerLink="/onboarding" class="ml-3 px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Sign up</button>
        </div>
    </div>


    <div class="flex w-full justify-center pt-16">
        <img [src]="assetUrl + 'img/analytics1.png'">
    </div>
</div>
<div class="flex flex-col justify-center py-24 px-20">
    <span class="text-md text-center">Trusted by 4,000+ companies</span>
    <div class="">
        <img [src]="assetUrl + 'img/trusted-logos.png'">
    </div>
</div>
<div class="flex flex-col px-[112px] pt-10 pb-24 text-center">
    <span class="text-md font-semibold text-purple pb-3">Features</span>
    <h2 class="text-3xl text-gray-900 pb-5">Why Customers Love Us</h2>
    <p class="text-gray-600">
        Spend smarter, lower your bills, get cashback on everything you buy, and unlock credit to grow your business.
    </p>
</div>

<div class="flex pl-24 pb-20 justify-between">
    <div class="flex flex-col px-8 py-20">
        <div class="flex flex-col pb-8">
            <img class="pb-6 w-12" [src]="assetUrl + 'icons/comment-circle.svg'">
            <h3 class="text-3xl pb-4">Effortless Booking & Scheduling</h3>
            <span class="text-lg">Stay organized and never miss a booking with our intuitive scheduling system.</span>
        </div>

        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Manage appointments seamlessly in a visual calendar.</p>
            </div>
        </div>
        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Send confirmations, cancellations, and reminders instantly.</p>
            </div>
        </div>
        <div class="flex items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Easily assign services to the right team members.</p>
            </div>
        </div>
    </div>
    <div class="">
        <img [src]="assetUrl + 'img/calendar1.png'" alt="why us">
    </div>
</div>

<div class="flex pr-20 pb-10 justify-between">
    <div class="">
        <img [src]="assetUrl + 'img/table3.png'" alt="custome-relationship">
    </div>

    <div class="flex flex-col pl-24 pr-8 py-20">
        <div class="flex flex-col pb-8">
            <img class="pb-6 w-12" [src]="assetUrl + 'icons/fast.svg'">
            <h3 class="text-3xl pb-4">Build Stronger Customer Relationships</h3>
            <span class="text-lg">Turn first-time visitors into loyal customers with personalized experiences.</span>
        </div>

        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Customer History & Preferences</p>
            </div>
        </div>
        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Send targeted discounts and special offers.</p>
            </div>
        </div>
        <div class="flex items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Reward repeat customers and attract new ones.</p>
            </div>
        </div>
    </div>
</div>



<div class="flex pl-20 pb-10 justify-between">
    <div class="flex flex-col px-8 py-20">
        <div class="flex flex-col pb-8">
            <img class="pb-6 w-12" [src]="assetUrl + 'icons/review.svg'">
            <h3 class="text-3xl pb-4">Grow with Powerful Insights & Marketing Tools</h3>
            <span class="text-lg">Optimize revenue and expand your business with data-driven decisions.</span>
        </div>

        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">
                    Monitor daily, weekly, and monthly earnings.
                </p>
            </div>
        </div>
        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">
                    Keep an eye on pending transactions and payment history.
                </p>
            </div>
        </div>
        <div class="flex items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">
                    Offer special deals to boost bookings.
                </p>
            </div>
        </div>
    </div>
    <div class="">
        <img [src]="assetUrl + 'img/table2.png'" alt="why us">
    </div>
</div>

<div class="flex flex-col">
    <div class="flex flex-col items-center pb-16">
        <img [src]="assetUrl + 'icons/fast.svg'" class='w-14 pb-6'>
        <h3 class="text-4xl pb-5">Unleash the full power of data</h3>
        <span class="text-xl text-gray-600">Everything you need to convert, engage, and retain more users.</span>
    </div>
    <div class="flex justify-center pb-24 px-20 text-center">
        <div class="flex flex-col w-60 font-semibold px-4 border-r border-gray-200">
            <span class="text-6xl text-purple-600 pb-3">96%</span>
            <span class="text-lg font-semibold">More Bookings</span>
        </div>
        
        <div class="flex flex-col w-60 font-semibold px-4 border-r border-gray-200">
            <span class="text-6xl text-purple-600 pb-3">$50K+</span>
            <span class="text-lg font-semibold">Revenue Growth</span>
        </div>

        <div class="flex flex-col w-60 font-semibold px-4">
            <span class="text-6xl text-purple-600 pb-3">2k+</span>
            <span class="text-lg">Satisfaction Review</span>
        </div>
    </div>
    <div class="flex px-[112px] pb-[64px]">
        <div class="flex p-[64px] w-full bg-gray-50 justify-between">
            <div class="flex flex-col">
                <p class="text-3xl pb-4">See more soulution & Plans?</p>
                <span class="text-gray-600">Join over 4,000+ startups already growing with Untitled.</span>
            </div>
            <div class="flex gap-x-3">
                <button class="px-6 py-2 shadow rounded-3xl text-gray-700">Learn More</button>
                <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">See Plans</button>
            </div>
        </div>
    </div>
</div>

<div class="flex flex-col w-full bg-gray-50 px-20 py-[96px]">
    <div class="flex flex-col items-center text-center pb-12">
        <h4 class="text-3xl pb-8">
            gloget has saved us thousands of hours of work and has unlock data insights we never thought possible.
        </h4>
        <img class="pb-4" [src]="assetUrl + 'img/avatar1.png'">
        <b class="pb-1">Ammar Foley</b>
        <span class="text-gray-600">Salon Owner</span>
    </div>
    <div class="flex partners justify-center">
        <img [src]="assetUrl + 'img/partner1.png'" class="px-4">
        <img [src]="assetUrl + 'img/partner2.png'" class="px-4">
        <img [src]="assetUrl + 'img/partner3.png'" class="px-4">
        <img [src]="assetUrl + 'img/partner4.png'" class="px-4">
        <img [src]="assetUrl + 'img/partner5.png'" class="px-4">
    </div>
</div>

<section class="p-20">
    <landing-our-blog></landing-our-blog>
</section>

<div class="flex pl-24 pt-[96px] justify-between">
    <div class="flex flex-col px-8 py-20">
        <div class="flex flex-col pb-8">
            <h3 class="text-3xl pb-4">Need more info about us?
            </h3>
        </div>

        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">30-day free trial
                </p>
            </div>
        </div>
        <div class="flex pb-5 items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Peronalized onboarding
                </p>
            </div>
        </div>
        <div class="flex items-center text-lg">
            <img [src]="assetUrl + 'icons/check.svg'" class="pr-3">
            <div class="flex flex-col">
                <p class="text-gray-600">Access to all features
                </p>
            </div>
        </div>
        <div class="flex pt-12">
            <button class="px-6 py-2 shadow rounded-3xl bg-white mr-3">Learn More</button>
            <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get Started</button>
        </div>
    </div>
    <div class="">
        <img [src]="assetUrl + 'img/table1.png'" alt="why us">
    </div>
</div>